import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_PREDICTION_HISTORY_LIST = "GET_PREDICTION_HISTORY_LIST";

export const service = async (lookBackPeriod) => {
  const options: object = {
    url: `/api/DenialsPredictor/GetPredictionHistoryList/`+ lookBackPeriod,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_PREDICTION_HISTORY_LIST, service, mock);
